
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 25 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.664 10.893l3.023-4.159a2.57 2.57 0 00-.57-3.593 2.565 2.565 0 00-3.59.569L5.501 7.872a2.572 2.572 0 104.165 3.021zm6.616-4.728L4.183 22.814a2.571 2.571 0 104.161 3.023L20.439 9.188a2.565 2.565 0 00-.569-3.59 2.568 2.568 0 00-3.59.568zM4.364.685a2.572 2.572 0 10-3.026 4.16A2.572 2.572 0 004.364.685zm15.33 27.036a2.572 2.572 0 104.16 3.025 2.572 2.572 0 00-4.16-3.025zm-4.73-6.616l-3.025 4.163A2.572 2.572 0 1016.1 28.29l3.025-4.162a2.574 2.574 0 00-.572-3.593 2.57 2.57 0 00-3.59.57z"}})])
          )
        }
      }
    